import React from 'react';
import { Seo } from '../components/ui/Seo';
import { Hero } from '../components/home/Hero';
import type { HeroHeadline } from '../components/home/Hero';
import { QuickStart } from '../components/home/QuickStart';
import { NextClasses } from '../components/home/NextClasses';
import { WhyHpp } from '../components/home/WhyHpp';
import { StatsBand } from '../components/home/StatsBand';
import { TrainingPath } from '../components/home/TrainingPath';
import { CourseGridSection } from '../components/home/CourseGridSection';
import { Instructors } from '../components/home/Instructors';
import { QuoteBand } from '../components/home/QuoteBand';
import { WomensBand } from '../components/home/WomensBand';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { PackagesTeaser } from '../components/home/PackagesTeaser';
import { CcwExplainer } from '../components/home/CcwExplainer';
import { FaqPreview } from '../components/home/FaqPreview';
import { CtaBand } from '../components/shared/CtaBand';
export function Home({
  heroHeadline
}: {
  heroHeadline: HeroHeadline;
}) {
  return <>
      <Seo title="Las Vegas CCW Class & Defensive Firearms Training" description="Sheriff-approved Las Vegas CCW class, Nevada CCW renewal, concealed carry and women’s firearms training in Las Vegas. Taught by CCW Maggie since 2010." data-id="element-821" data-mp="2vyq964e3me8a" />
      <Hero headline={heroHeadline} data-id="element-822" data-mp="2hxx974512qxs" />
      <QuickStart data-id="element-823" data-mp="2hyyxwbeyvbxz" />
      <NextClasses data-id="element-824" data-mp="2hzi5ozawkjya" />
      <WhyHpp data-id="element-825" data-mp="2i00bonndacje" />
      <StatsBand data-id="element-826" data-mp="2d774zu8c8u4o" />
      <TrainingPath data-id="element-827" data-mp="2d6p1ccjcjdmq" />
      <CourseGridSection data-id="element-828" data-mp="2d65srmfl61ld" />
      <Instructors data-id="element-829" data-mp="2d5w17uew7mdk" />
      <QuoteBand data-id="element-830" data-mp="2d5dv862fhtsg" />
      <WomensBand data-id="element-831" data-mp="287uixbpajr35" />
      <ReviewsSection data-id="element-832" data-mp="287ch7zjv0knu" />
      <PackagesTeaser data-id="element-833" data-mp="288nhvqi0dcaq" />
      <CcwExplainer data-id="element-834" data-mp="2861du0ubtex9" />
      <FaqPreview data-id="element-835" data-mp="23912baepjjyr" />
      <CtaBand data-id="element-836" data-mp="239spbwu8o9df" />
    </>;
}